module.exports = __webpack_public_path__ + "img/xwzxk2.4909919c.png";